import { notifyErrorNotAuthRelated } from "@/api/utils";

import { searchKeys } from "@/helper/SessionStorageKeys.ts";
import { useAuthStore } from "@/store/AuthStore.ts";
import qs from "querystringify";
import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalizedGeneric,
} from "vue-router";
import routes from "~pages";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function guardClearCustomerPageSessionCache(
  to: RouteLocationNormalizedGeneric,
) {
  Object.entries(searchKeys).forEach(([domain, keys]) => {
    if (!to.path.startsWith(domain)) {
      keys.forEach((key) => sessionStorage.removeItem(key));
    }
  });
}
async function guardAuthenticated(to: RouteLocationNormalizedGeneric) {
  const authStore = useAuthStore();

  /** Pages Config and Login don't require to be logged in. */
  if (!authStore.isLoggedIn && !to.meta.withoutAuth) {
    await authStore
      .updateSession()
      .then(async (isLoggedIn) => {
        if (!isLoggedIn) {
          await router.replace(
            "/login" + qs.stringify({ next: to.path }, true),
          );
        }
      })
      .catch(notifyErrorNotAuthRelated);
  }
}

router.beforeEach(async (to) => {
  guardClearCustomerPageSessionCache(to);
  await guardAuthenticated(to);
});

export default router;
